import { useSetting } from '../../../util/useSetting';
import { useEffect, useState } from 'react';
import { teacherFetchStudentAnswers } from '../../../services2/studentAnswers.service';
import { connect } from 'react-redux';
function InteractiveAreaAnswer(props) {
    const { fontSize } = useSetting();

    const [showMore, setShowMore] = useState(false);
    const handleShowMore = () => {
        setShowMore(!showMore);
    }
    const [answers, setAnswers] = useState([]);

    async function fetchAnswer() {
        if (props.type === '核心問題') {
            let result = await teacherFetchStudentAnswers(props.token.token, {
                questionId: `core_${props.index}`,
                status: 'active',
                session: props.index === 0 ? '互文閱讀一' : '互文閱讀二',
                schoolMissionId: props.schoolMissionId
            }, {});
            setAnswers(result?.result);
        } else if (props.type === '短答題') {
            let result = await teacherFetchStudentAnswers(props.token.token, {
                questionId: `practice_${props.index}_${props.data?.id}`,
                status: 'active',
                session: props.index === 0 ? '互文閱讀一' : '互文閱讀二',
                schoolMissionId: props.schoolMissionId
            }, {});
            setAnswers(result?.result);
        }
    }
    useEffect(() => {
        fetchAnswer();
    }, [props.data, props.index, props.schoolMissionId]);

    if (props.type === '核心問題')
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', fontSize: fontSize }}>
                <div className='text-white p-[16px]' style={{ fontSize: fontSize + 2 }}>核心問題</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                    <div>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
                    <div className='text-[#9F0000]' style={{}}>學生答案結果</div>
                    <div className='flex flex-row flex-wrap gap-[8px]'>
                        {(showMore ? answers : answers?.slice(0, 10))?.map((answer, index) => (
                            <div key={index} className='p-[8px] rounded-[8px] bg-[#015B6B] text-white font-[400] px-[24px]'>
                                {answer?.answer}
                            </div>
                        ))}
                    </div>
                    <div className='flex flex-row justify-center mt-[12px]'>
                        <button onClick={handleShowMore} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white px-[4px] py-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                            <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                                {showMore ? '收起學生答案' : '更多學生答案'}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        )
    else if (props.type === '短答題') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div>{props.data?.question}</div>

                    <div className='text-[#9F0000]' style={{}}>學生答案結果</div>
                    <div className='flex flex-row flex-wrap gap-[8px]'>
                        {(showMore ? answers : answers?.slice(0, 10))?.map((answer, index) => (
                            <div key={index} className='p-[8px] rounded-[8px] bg-[#015B6B] text-white font-[400] px-[24px]'>
                                {answer?.answer}
                            </div>
                        ))}
                    </div>
                    <div className='flex flex-row justify-center mt-[12px]'>
                        <button onClick={handleShowMore} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white px-[4px] py-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                            <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                                {showMore ? '收起學生答案' : '更多學生答案'}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return null
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(InteractiveAreaAnswer)
